import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@crehana/compass.ui/dialog';

import { useCourseDetailTranslation } from '../../../../hooks/useCourseDetailTranslation';
import { EnrollmentsCurrentCourseTable } from './leader-enrollments-course-table';

type TEnrollmentsCurrentCourseDialogProps = {
  courseId: string;
  courseTitle: string;
};

export const EnrollmentsCurrentCourseDialog: React.FC<
  React.PropsWithChildren<TEnrollmentsCurrentCourseDialogProps>
> = ({ children, courseId, courseTitle }) => {
  const { t } = useCourseDetailTranslation();

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>

      <DialogContent>
        <DialogHeader className="tw-font-subtitle4 tw-border-solid tw-border-b tw-border-neutral-light-400 tw-pb-1.2 tw-pt-1.6 tw-px-1.2 sm:tw-px-2.4 tw-text-left">
          {t('ENROLLMENTS_CURRENT_COURSE_DIALOG_TITLE')}
        </DialogHeader>

        <section className="tw-p-1.2 sm:tw-p-2.4 tw-max-h-[40rem]">
          <p className="tw-font-body5 tw-text-neutral-light-700 tw-text-left tw-mb-1.6">
            {t('ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION')}{' '}
            <b>{t('ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION_BOLD')}</b>
          </p>

          <section className="tw-pb-1.2 sm:tw-pb-2.4">
            <EnrollmentsCurrentCourseTable
              courseId={courseId}
              courseTitle={courseTitle}
              pageSize={10}
            />
          </section>
        </section>
      </DialogContent>
    </Dialog>
  );
};
